// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-list--vertical{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #fff;
    padding: calc(var(--safe-area-top) + 32px) 1rem calc(var(--safe-area-bottom) + 1rem) 1rem;
    z-index: 10;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
}
.menu-list--vertical .app-header{
    padding: 0 ;
}
.menu-list.hidden{
    display: none;
}

.menu-list__item,
.menu-list__item:link,
.menu-list__item:hover,
.menu-list__item:focus,
.menu-list__item:active,
.menu-list__item:visited{
    text-decoration: none!important;
    outline: none!important;
    background-color: transparent!important;
    text-decoration-color: transparent!important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
}
.menu-list .MuiIconButton-root.menu-icon-btn{
    padding: 10px  0;
    width: 100%;
    justify-content: left;
}

nav header {
    padding-top: 15px;
    padding-bottom: 20px;
}
.menu-list__item .menu-icon-btn__list-item.MuiIconButton-root{
    padding-top: 10px;
    padding-bottom: 10px;
}
@media screen and (max-height: 545px) {
    .menu-list__item .menu-icon-btn__list-item.MuiIconButton-root{
        padding-top: 8px;
        padding-bottom: 8px;
    }

}
.app-menu-header--mobile{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 10px 16px 0;
    box-sizing: border-box;
}
.app-header-menu__user-preferences-container--mobile{
    position: relative;
    width: fit-content;
}
.app-header-menu__user-preferences-container--mobile::before{
    content: '';
    width: 50px;
    height: 50px;
    position: absolute ;
    background-color: var(--app__profile-icon--bg-color);
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    border-radius: 50%;
}
.inline-label-menu-button-sidebar-menu-item.custom-menu-button__container{
    padding: 10px 0;
}
.inline-label-menu-button__icon-container{
    padding: 5px 10px 3px 5px;
}
@media screen and (min-width: 480px){
    .app-header-menu__user-preferences-container--mobile{
        display: none;
    }
    .inline-label-menu-button-sidebar-menu-item.custom-menu-button__container{
        padding: 12px;
        gap: 16px;
    }
    .inline-label-menu-button__icon-container{
        padding: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/core/components/lists/MenuIconBtnList/MenuIconBtnList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,sBAAsB;IACtB,yFAAyF;IACzF,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;;AAEA;;;;;;IAMI,+BAA+B;IAC/B,uBAAuB;IACvB,uCAAuC;IACvC,4CAA4C;IAC5C,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,wCAAwC;IACxC,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;IACpD,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,SAAS;IACb;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".menu-list--vertical{\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    position: fixed;\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: #fff;\n    padding: calc(var(--safe-area-top) + 32px) 1rem calc(var(--safe-area-bottom) + 1rem) 1rem;\n    z-index: 10;\n    height: 100%;\n    overflow-y: scroll;\n    box-sizing: border-box;\n}\n.menu-list--vertical .app-header{\n    padding: 0 ;\n}\n.menu-list.hidden{\n    display: none;\n}\n\n.menu-list__item,\n.menu-list__item:link,\n.menu-list__item:hover,\n.menu-list__item:focus,\n.menu-list__item:active,\n.menu-list__item:visited{\n    text-decoration: none!important;\n    outline: none!important;\n    background-color: transparent!important;\n    text-decoration-color: transparent!important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    width: 100%;\n}\n.menu-list .MuiIconButton-root.menu-icon-btn{\n    padding: 10px  0;\n    width: 100%;\n    justify-content: left;\n}\n\nnav header {\n    padding-top: 15px;\n    padding-bottom: 20px;\n}\n.menu-list__item .menu-icon-btn__list-item.MuiIconButton-root{\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n@media screen and (max-height: 545px) {\n    .menu-list__item .menu-icon-btn__list-item.MuiIconButton-root{\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n}\n.app-menu-header--mobile{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0 10px 16px 0;\n    box-sizing: border-box;\n}\n.app-header-menu__user-preferences-container--mobile{\n    position: relative;\n    width: fit-content;\n}\n.app-header-menu__user-preferences-container--mobile::before{\n    content: '';\n    width: 50px;\n    height: 50px;\n    position: absolute ;\n    background-color: var(--app__profile-icon--bg-color);\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    border-radius: 50%;\n}\n.inline-label-menu-button-sidebar-menu-item.custom-menu-button__container{\n    padding: 10px 0;\n}\n.inline-label-menu-button__icon-container{\n    padding: 5px 10px 3px 5px;\n}\n@media screen and (min-width: 480px){\n    .app-header-menu__user-preferences-container--mobile{\n        display: none;\n    }\n    .inline-label-menu-button-sidebar-menu-item.custom-menu-button__container{\n        padding: 12px;\n        gap: 16px;\n    }\n    .inline-label-menu-button__icon-container{\n        padding: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
